module.exports = __webpack_public_path__ + "img/fst.e5f52c1d.jpg";